var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }